import PropTypes from 'prop-types';
import styles from './Progress.module.css';

export default function Progress({ percentage = 0 }) {
    return (
        <div className={styles.container}>
            <div className={styles.label}>COMPLETE</div>
            <div className={styles.percentage}>{percentage}%</div>
        </div>
    );
}

Progress.propTypes = {
    percentage: PropTypes.number
};
